import React, { Component } from 'react';
import { Typography, Tabs } from 'antd';

import FetcherView from './fetcher_view';
import ParsersView from './parsers_view';
import BatchersView from './batchers_view';
import AggregatorsView from './aggregators_view';
import ReconcilersView from './reconcilers_view';
import DashboardWidgetsView from './dashboard_widgets_view';
import EnrichersView from './enrichers_view';
import EvalPluginView from './evalplugin_view';
import EvalVariableView from './eval_variables';
import ReportPluginView from './report_plugin_view';
import ReportActionsView from './report_actions_view';
import DataSourceView from './datasource_view';
import DashboardTabsView from './dashboard_tabs_view';
import SelectorConfigView from './selector_config_view';
import SmartActionsView from './smart_actions_view';
import ChroneJobsView from './chrone_jobs';
import UnreconciledActions from './unreconciled_actions';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import GeneralPlugin from './general_plugin';

const { Title } = Typography;
const queryString = require('query-string');

const { TabPane } = Tabs;

const plugin_items = [
    {
        title: "Fetchers",
        key: "0",
        content: <GeneralPlugin
            title="Fetcher List"
            api="/fetchers"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "Version",
                    dataIndex: 'version',
                    key: 'version'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Parsers",
        key: "1",
        content: <GeneralPlugin
            title="Parser List"
            api="/parsers"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "Version",
                    dataIndex: 'version',
                    key: 'version'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Enrichers",
        key: "2",
        content: <GeneralPlugin
            title="Enricher List"
            api="/enrichers"
            columns={[
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Batchers",
        key: "3",
        content: <GeneralPlugin
            title="Batcher List"
            api="/batchers"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Processors",
        key: "4",
        content: <GeneralPlugin
            title="Processor List"
            api="/reconciler-comparators"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Functions",
        key: "5",
        content: <GeneralPlugin
            title="Function List"
            api="/eval-functions"
            columns={[
                // {
                //     title:"NAME",
                //     dataIndex:'name',
                //     key:'name'
                // },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Variables",
        key: "6",
        content: <GeneralPlugin
            title="Variable List"
            api="/eval-variables"
            columns={[
                // {
                //     title:"NAME",
                //     dataIndex:'name',
                //     key:'name'
                // },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Reports",
        key: "7",
        content: <GeneralPlugin
            title="Report List"
            api="/report-plugins"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Report Actions",
        key: "8",
        content: <GeneralPlugin
            title="Report Action List"
            api="/report-actions"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Datasources",
        key: "9",
        content: <GeneralPlugin
            title="Datasource List"
            api="/data-sources"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                },
                {
                    title: "Description",
                    dataIndex: 'description',
                    key: 'description'
                }
            ]}
        />
    },
    {
        title: "Dashboard Widgets",
        key: "10",
        content: <GeneralPlugin
            title="Dashboard Widget List"
            api="/dashboard-widgets"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                },
                {
                    title: "Widget Type",
                    dataIndex: 'widget_type',
                    key: 'widget_type'
                }
            ]}
        />
    },
    {
        title: "Dashboard Tabs",
        key: "11",
        content: <GeneralPlugin
            title="Dashboard Tab List"
            api="/dashboard-tabs"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                },
                {
                    title: "Description",
                    dataIndex: 'description',
                    key: 'description'
                }
            ]}
        />
    },
    {
        title: "Selectors",
        key: "12",
        content: <GeneralPlugin
            title="Selector List"
            api="/selectors"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Smart Actions",
        key: "13",
        content: <GeneralPlugin
            title="Smart Action List"
            api="/smart-actions"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Unprocessed Actions",
        key: "14",
        content: <GeneralPlugin
            title="Unprocessed Action List"
            api="/unreconciled-actions"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                }
            ]}
        />
    },
    {
        title: "Cron Jobs",
        key: "15",
        content: <GeneralPlugin
            title="Cron Job List"
            api="/cron-jobs"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                },
                {
                    title: "Description",
                    dataIndex: 'description',
                    key: 'description'
                }
            ]}
        />
    },
    {
        title: "Transaction Actions",
        key: "16",
        content: <GeneralPlugin
            title="Transaction Action List"
            api="/transaction-actions"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                },
                {
                    title: "Description",
                    dataIndex: 'description',
                    key: 'description'
                }
            ]}
        />
    },
    {
        title: "Async Jobs",
        key: "17",
        content: <GeneralPlugin
            title="Async Job List"
            api="/async-jobs"
            columns={[
                {
                    title: "NAME",
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: "ID",
                    dataIndex: 'id',
                    key: 'id'
                },
                {
                    title: "Description",
                    dataIndex: 'description',
                    key: 'description'
                }
            ]}
        />
    },
    // {
    //     title:"Fetchers",
    //     key:"1",
    //     content:<FetcherView/>
    // },
    // {
    //     title:"Parsers",
    //     key:"2",
    //     content:<ParsersView />
    // },
    // {
    //     title:"Enrichers",
    //     key:"3",
    //     content:<EnrichersView/>
    // },
    // {
    //     title:"Batchers",
    //     key:"4",
    //     content:<BatchersView />
    // },
    // {
    //     title:"Reconcilers",
    //     key:"6",
    //     content:<ReconcilersView />
    // },
    // {
    //     title:"Functions",
    //     key:"7",
    //     content:<EvalPluginView />
    // },
    // {
    //     title:"Variables",
    //     key:"8",
    //     content:<EvalVariableView />
    // },
    // {
    //     title:"Reports",
    //     key:"9",
    //     content:<ReportPluginView />
    // },
    // {
    //     title:"Report Actions",
    //     key:"10",
    //     content:<ReportActionsView />
    // },
    // {
    //     title:"Data Sources",
    //     key:"11",
    //     content:<DataSourceView />
    // },
    // {
    //     title:"Dashbord Widgets",//<div>Dashboard<br></br>Widgets</div>,
    //     key:"12",
    //     content:<DashboardWidgetsView />
    // },
    // {
    //     title:"Dashbord Tabs",//<div>Dashboard<br></br>Tabs</div>,
    //     key:"13",
    //     content:<DashboardTabsView />
    // },
    // {
    //     title:<div>Selectors</div>,
    //     key:"14",
    //     content:<SelectorConfigView />
    // },
    // {
    //     title:<div>Smart Actions</div>,
    //     key:"15",
    //     content:<SmartActionsView />
    // },
    // {
    //     title:<div>Unprocessed Actions</div>,
    //     key:"16",
    //     content:<UnreconciledActions />
    // },
    // {
    //     title:<div>Cron Jobs</div>,
    //     key:"17",
    //     content:<ChroneJobsView />
    // }

]

class PluginsSetting extends Component {
    constructor(props) {
        super(props)

        this.state = {
            tab: '0'
        }
    }

    render() {
        const { tab } = this.state
        return (
            <div>
                <BasicHeader no_back title="Plugins"
                    menu_items={setting_quick_menu}
                />
                <div className='default-card' style={{
                    padding: 8,
                    paddingLeft: 16,
                    paddingRight: 16
                }}>
                    {/* <Title style={{
                textAlign:'left'
            }}>Plugins</Title> */}
                    <Tabs tabPosition='top' activeKey={tab} onTabClick={(tab) => {
                        this.props.history.push({
                            search: queryString.stringify({ tab: tab })
                        })
                    }}>
                        {
                            plugin_items.map((item) => {
                                return <TabPane key={item.key}

                                    tab={item.title}
                                >
                                    <div style={{
                                        minHeight: 500,
                                    }}>
                                        {item.content}
                                    </div>
                                </TabPane>
                            })
                        }

                    </Tabs>
                </div>
            </div>
        );
    }

    componentDidMount() {
        let new_tab_data = {
            tab: "0"
        };
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_tab_data = { ...new_tab_data, ...parsed };
        }
        this.setState({
            ...new_tab_data
        });
    }

    componentWillReceiveProps(nextProps) {

        let new_tab_data = {
            tab: "1"
        };
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_tab_data = { ...new_tab_data, ...parsed };
            this.setState({
                ...new_tab_data
            });
        } else {
            //   this.list_logs.execute()
        }


    }


}

export default PluginsSetting;
